export default function PlaygroundBadge() {
  return (
    <div className="fixed right-4 top-4 z-50 rounded-full bg-yellow-500 px-4 py-2 text-sm font-semibold text-black shadow-lg">
      Playground Mode
    </div>
  );
}